import { Component, Input, OnInit, ViewChild, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataStateChangeEventArgs, GridComponent, SortEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { L10n, setCulture } from '@syncfusion/ej2-base';
import { Observable } from 'rxjs';
import { isInternalUserRole, UserRoles } from 'src/app/data/models';
import { AuthenticationService, CompanyService } from 'src/app/core/services';
import { GlobalConstants } from 'src/app/shared/services/constants/globalconstants';
import { ManageInformationLinksPaginationService } from './information-links.service';
import { ToastCloseArgs, ToastComponent, ToastPositionModel } from '@syncfusion/ej2-angular-notifications';
import { ToastService } from 'src/app/core/services/taoastService/toast-service.service';
import { DialogUtility } from '@syncfusion/ej2-popups';
import printJS from 'print-js';
import { ManageInfoLinksModel } from 'src/app/data/models/settings/manage-info-links.model';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { CsvService } from 'src/app/shared/services/exportFiles/csv/csv.service';
import { ExcelService } from 'src/app/shared/services/exportFiles/xlsx/excel.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { InformationLinkViewModel } from './information-links';
import { PagerDropdownFixService } from 'src/app/shared/services/grid/pager-dropdown-fix.service';

@Component({
    selector: 'app-information-links',
    templateUrl: './information-links.component.html',
    styleUrls: ['./information-links.component.scss'],
    standalone: false
})
export class InformationLinksComponent implements OnInit {
  @Input() public companyId: any;
  @Input() public path = '';
  companydetails: any;
  @ViewChild('informationLinksGrid')
  grid: GridComponent;

  public winInnerHeight: number = this.winHeight;
  // for dynamic height purpose
  public tableHeight: any = 'auto';
  public isManageInfoList = false;

  clientCompany: Observable<any[]>;
  infoLinksForm: UntypedFormGroup;
  ManageInfoList: Observable<DataStateChangeEventArgs>;
  editStatus = false;
  isSorting: boolean;
  infoLinksList: boolean;
  addInfoLinks: boolean;
  DialogObj: any;
  @ViewChild('toasttype')
  private toastObj: ToastComponent;
  toastPosition: ToastPositionModel = { X: 'Right' };
  isGridLoading = true;
  loadingGridMessage = GlobalConstants.loadingGridMessage;
  noRecordMessage = GlobalConstants.norecordMessage;
  submitted = false;
  @Input() tabElement: any;
  currentUser: any;
  LoggedinUserAccountID: any;
  pageInfo: any;
  filter: Object;
  filterSettings: Object;
  selectionSettings: Object;
  initialPage: any;
  editSettings: Object;
  toolbar: any;
  currentState: any;
  Userroles: any;
  CompanyPlaceholder = 'Company';
  companyFields: Object = { text: 'Name', value: 'CompanyId' };
  columnNameToSort: any;
  sortingType: any;
  informationLinkTitle = '';
  isInformationLinks = false;
  userRoles: any;
  isInternalUser = false;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthenticationService,
    private companyService: CompanyService,
    private ManageInfoLinksPaginationService: ManageInformationLinksPaginationService,
    private toastService: ToastService,
    private csvService: CsvService,
    private excelService: ExcelService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private pagerDropdownFix: PagerDropdownFixService
  ) {
    this.userRoles = UserRoles;
    this.authService.currentUser.subscribe(user => this.currentUser = user);
    this.Userroles = UserRoles;
    this.ManageInfoList = ManageInfoLinksPaginationService;
    this.activatedRoute.paramMap.subscribe((param) => {
      if (this.activatedRoute.snapshot.url[0].path === 'edit') {
        this.path = 'edit';
      } else if (this.activatedRoute.snapshot.url[0].path === 'view') {
        this.path = 'view';
      } else if (this.activatedRoute.snapshot.url[0].path === 'add') {
        this.path = 'add';
      }
    });
  }

  ngOnInit(): void {
    this.isInformationLinks = this.router.url !== `/${GlobalConstants.InformationLinksRoute}`;
    if (!this.currentUser) {
      this.currentUser = JSON.parse(localStorage.getItem('currentuser'));
      this.isInternalUser = isInternalUserRole(this.currentUser.UserRoleID);
    }
    this.companyId = this.companyId ?? this.currentUser.Company.CompanyID;
    this.spinner.show('customSpinner');
    setCulture('en-US');
    L10n.load({
      'en-US': {
        pager: {
          currentPageInfo: '',
          totalItemsInfo: '{1} to {2} of {0}',
        }
      }
    });

    this.initializeform();
    if (this.currentUser.UserRoleID != UserRoles.Administrator) {
      this.toolbar = this.toolbar.filter(function (el: { id: string }) { return el.id != 'add' && el.id != 'deleteAll'; });
    }

    this.bindCompany();
    this.infoLinksList = true;
    this.addInfoLinks = false;

    this.pagerDropdownFix.enable();
  }

  initializeform() {
    this.infoLinksForm = this.formBuilder.group({
      search: [],
      companyId: [this.companyId],
      companyInformationLinkId: [0],
      link: ['', Validators.required],
      description: ['', Validators.required],
      notes: ['']
    });

    this.LoggedinUserAccountID = this.currentUser.UserAccountID;
    this.pageInfo = { PageNumber: 1, PageSize: 10, Query: '' };
    this.filterSettings = { type: 'Menu' };
    this.filter = { type: 'CheckBox' };

    this.selectionSettings = { persistSelection: true, type: 'Multiple', checkboxOnly: true };
    this.editSettings = { allowDeleting: false, allowAdding: true };
    this.initialPage = { pageSizes: ['10', '25', '50', '100'], pageSize: 25, pageNumber: 1, Query: '', currentPage: 1 };
    this.toolbar = [
      ...(this.path !== 'view' ? [
    { text: 'Add', tooltipText: 'Add', prefixIcon: 'e-plus ', id: 'add', routerLink: '[\'\']', cssClass: 'e-tool-primary-item e-ml-3' },
    { text: 'Delete', tooltipText: 'Delete', prefixIcon: 'e-remove e-danger', id: 'deleteAll' }
  ] : []),
    { text: 'PDF', tooltipText: 'Export to PDF', prefixIcon: 'e-pdfexport', id: 'pdf', cssClass: this.path === 'view' ? 'e-ml-3' : 'e-ml-0' },
    { text: 'Excel', tooltipText: 'Export to Excel', prefixIcon: 'e-excelexport', id: 'excel' },
    { text: 'CSV', tooltipText: 'Export to CSV', prefixIcon: 'e-csvexport', id: 'csv' },
    { text: 'Print', tooltipText: 'Print Records', prefixIcon: 'e-print', id: 'print' },
    // { text: 'Reset Filter', tooltipText: 'Reset Filter', prefixIcon: 'e-clear-icon', id: 'reset' },
    { text: 'Refresh', tooltipText: 'Refresh Grid', prefixIcon: 'e-redo-dot', id: 'refresh' },
    ];

    const state = { skip: 0, take: 25 };
    this.currentState = state;
    this.currentUser = this.authService.CurrentUserValue;
    this.ManageInfoLinksPaginationService.execute(state, this.companyId);
  }

  showAddList() {
    this.isGridLoading = true;
    this.spinner.show('customSpinner');
    this.infoLinksList = true;
    this.addInfoLinks = false;
    const state = { skip: 0, take: 25 };
    this.currentState = state;
    this.ManageInfoLinksPaginationService.execute(state, this.companyId);
  }

  get formControl() { return this.infoLinksForm.controls; }

  bindCompany() {
    this.companyService.getCompanyById(this.companyId).subscribe(res => {
      this.companydetails = res;
    }, error => {

    });
  }

  onDataBound(e: any) {
    if (this.grid.dataSource != null) {
      this.isGridLoading = false;
      this.spinner.hide('customSpinner');

      setTimeout(() => {
        this.getMovableContentHeight();
      }, 100);
    }

    this.grid.hideScroll();
  }

  rowDataBound(args: any) {
    if (args.data.UserAccountID == this.LoggedinUserAccountID) {
      args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox');
      args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox');
      args.row.getElementsByClassName('e-checkbox-wrapper')[0].disablecheckbox == true;
    }
  }

  dataStateChange(state: any): void {
    if (state.action.requestType != 'refresh') {
      this.currentState.take = state.take;
      this.grid.hideSpinner();
      this.isGridLoading = true;
      this.spinner.show('customSpinner');
      if (!this.isSorting && (state.action.previousPage != state.action.currentPage || state.action.requestType == 'paging')) {
        const currentSearch = this.currentState.search;
        this.currentState = state;
        state.search = currentSearch;
        this.ManageInfoLinksPaginationService.execute(state, this.companyId);
      } else if (this.isSorting && (state.action.previousPage != state.action.currentPage || state.action.requestType == 'paging')) {
        const currentSearch = this.currentState.search;
        state.search = currentSearch;
        this.currentState = state;
        this.getSortedData();
      }
    }
  }

  onBeforeOpen(e) {
    if (this.toastObj.element.children.length > 0) {
      if (e.options.content == this.toastService.getToastContent()) {
        e.cancel = true;
      }
    } else {
      this.toastService.setToastContent(e.options.content);
    }
  }

  close(e: ToastCloseArgs) {
    this.toastService.setToastStatus(false);
  }

  toolbarClick(args: ClickEventArgs) {
    const toolbarEvent = args.item.id;
    switch (toolbarEvent) {
      case 'add':
        this.informationLinkTitle = 'Add Information Link';
        this.openInfoLinkAddForm();
        break;
      case 'print':
        this.exportToPrint();
        break;
      case 'excel':
        this.exportToExcel();
        break;
      case 'csv':
        this.exportToCSV();
        break;
      case 'deleteAll':
        this.deleteAll();
        break;
      case 'pdf':
        this.exportToPdf();
        break;
      case 'refresh':
        this.refereshGrid();
        break;
    }
  }

  actionClick(companyInformationLinkId: any, action: any) {
    switch (action) {
      case 'edit':
        this.editStatus = true;
        this.informationLinkTitle = 'Edit Information Link';
        this.editcompanyInformationLink(companyInformationLinkId);
        break;
      case 'delete':
        this.delete(companyInformationLinkId);
        break;
    }
  }

  onSubmit() {
    this.spinner.show('customSpinner');
    this.submitted = true;
    if (this.infoLinksForm.valid) {
      this.infoLinksForm.value.companyId = Number(this.companyId);
      if (!this.editStatus) {//add
        this.ManageInfoLinksPaginationService.postInfoLink(this.infoLinksForm.value).subscribe(res => {
          this.spinner.hide('customSpinner');
          this.toastObj.show({ content: 'Information Link saved successfully', cssClass: 'e-toast-success', icon: 'e-success toast-icons' });
          this.ManageInfoLinksPaginationService.execute(this.currentState, this.companyId);
          this.showAddList();
        }, error => {
          this.spinner.hide('customSpinner');
          this.toastObj.show({ content: error.error.Message, cssClass: 'e-toast-danger', icon: 'e-error toast-icons' });
        });
      }
      else {//update
        this.ManageInfoLinksPaginationService.putInfoLink(this.infoLinksForm.value).subscribe(res => {
          this.spinner.hide('customSpinner');
          this.toastObj.show({ content: 'Information Link updated successfully', cssClass: 'e-toast-success', icon: 'e-success toast-icons' });
          this.ManageInfoLinksPaginationService.execute(this.currentState, this.companyId);
          this.showAddList();
        }, error => {
          this.spinner.hide('customSpinner');
          this.toastObj.show({ content: error.error.Message, cssClass: 'e-toast-danger', icon: 'e-error toast-icons' });
        });
      }
    }
    else {
      this.spinner.hide('customSpinner');
      return;
    }
  }

  editcompanyInformationLink(companyInformationLinkId: any) {
    this.spinner.show('customSpinner');
    this.ManageInfoLinksPaginationService.getInfoLinkById(companyInformationLinkId).subscribe(res => {
      this.infoLinksForm.get('link').setValue(res.LinkUrltext);
      this.infoLinksForm.get('description').setValue(res.LinkDescriptText);
      this.infoLinksForm.get('notes').setValue(res.LinkNotesText);
      this.infoLinksForm.get('companyInformationLinkId').setValue(companyInformationLinkId);
      this.infoLinksList = false;
      this.addInfoLinks = true;
      this.spinner.hide('customSpinner');
    }, error => {
      this.spinner.hide('customSpinner');
    });
  }

  delete(companyInformationLinkId: any) {
    this.DialogObj = DialogUtility.confirm({
      title: 'Delete Information Link',
      content: 'Are you sure you want to delete Information Link?',
      okButton: { text: 'Delete', click: this.deleteInformationLinkConfirmed.bind(this, companyInformationLinkId), cssClass: 'e-danger' }, 
      cancelButton: { text: 'Cancel', click: this.cancelClick.bind(this), cssClass: 'e-outline' },
      showCloseIcon: false,
      closeOnEscape: false,
      animationSettings: { effect: 'Zoom' },
      zIndex: 1005,
      position: { X: 'center', Y: 'center' },
      isModal: true
    });
  }

  private cancelClick(): void {
    this.DialogObj.hide();
  }

  deleteInformationLinkConfirmed(companyInformationLinkId: any) {
    this.spinner.show('customSpinner');
    this.ManageInfoLinksPaginationService.deleteInfoLink(companyInformationLinkId).subscribe(res => {
      this.spinner.hide('customSpinner');
      this.isGridLoading = true;
      this.ManageInfoLinksPaginationService.execute(this.currentState, this.companyId);
      this.DialogObj.hide();
      this.toastObj.show({ content: 'Successfully deleted Information Link', cssClass: 'e-toast-success', icon: 'e-success toast-icons' });
    }, err => {
      this.spinner.hide('customSpinner');
      this.DialogObj.hide();
      this.toastObj.show({ content: err.error.Message, cssClass: 'e-toast-danger', icon: 'e-error toast-icons' });
    });
  }

  deleteAll() {
    const companyInformationLinkIds = [];
    const selectedRecords = this.grid.getSelectedRecords();
    if (selectedRecords.length > 0) {
      selectedRecords.forEach((element: InformationLinkViewModel) => {
        companyInformationLinkIds.push(element.CompanyInformationLinkId);
      });
      this.DialogObj = DialogUtility.confirm({
        title: 'Delete Information Link(s)',
        content: 'Are you sure you want to delete Information Link(s)?',
        okButton: { text: 'Delete', click: this.deleteAllInformationLinksConfirmed.bind(this, companyInformationLinkIds), cssClass: 'e-danger' },
        cancelButton: { text: 'Cancel', click: this.cancelClick.bind(this), cssClass: 'e-outline' },
        showCloseIcon: false,
        closeOnEscape: false,
        animationSettings: { effect: 'Zoom' },
        zIndex: 1005,
        position: { X: 'center', Y: 'center' },
        isModal: true
      });
    }
    else {
      this.toastObj.show({ content: 'No records selected', cssClass: 'e-toast-danger', icon: 'e-error toast-icons' });
    }

    this.resetPageHeight();
  }

  deleteAllInformationLinksConfirmed(companyInformationLinkIds: any): void {
    this.spinner.show('customSpinner');
    this.ManageInfoLinksPaginationService.deleteAllInfoLinks(companyInformationLinkIds).subscribe(res => {
      this.spinner.hide('customSpinner');
      this.DialogObj.hide();
      this.toastObj.show({ content: 'Successfully deleted Information Links', cssClass: 'e-toast-success', icon: 'e-success toast-icons' });
      this.isGridLoading = true;
      this.ManageInfoLinksPaginationService.execute(this.currentState, this.companyId);
    }, err => {
      this.spinner.hide('customSpinner');
      this.DialogObj.hide();
      this.toastObj.show({ content: err.error.Message, cssClass: 'e-toast-danger', icon: 'e-error toast-icons' });
    });
  }

  openInfoLinkAddForm() {
    this.infoLinksForm.get('companyId').setValue(this.companyId);
    this.infoLinksForm.get('link').setValue('');
    this.infoLinksForm.get('description').setValue('');
    this.infoLinksForm.get('notes').setValue('');
    this.editStatus = false;
    this.submitted = false;
    this.addInfoLinks = true;
    this.infoLinksList = false;
  }

  sort(sortEventArgs: SortEventArgs) {
    switch (sortEventArgs.requestType) {
      case 'sorting':
        if (sortEventArgs.direction != undefined) {
          this.isSorting = sortEventArgs.requestType == 'sorting';

          this.columnNameToSort = sortEventArgs.columnName == 'Company.Display' ? 'CompanyDisplay' : sortEventArgs.columnName;
          this.sortingType = sortEventArgs.direction;
          this.getSortedData();
        } else {
          this.isSorting = false;
          this.isGridLoading = true;
          this.ManageInfoLinksPaginationService.execute(this.currentState, this.companyId);
        }
        break;

      case 'paging':
        break;
      case 'refresh':
        break;
      default:
        this.isSorting = false;
        this.isGridLoading = true;
        this.ManageInfoLinksPaginationService.execute(this.currentState, this.companyId);
        break;
    }

  }

  getSortedData() {
    let isDescSort = false;
    isDescSort = this.sortingType.toLowerCase() == 'descending';
    this.isGridLoading = true;
    this.ManageInfoLinksPaginationService.executeSorting
      (
        this.currentState,
        this.companyId,
        this.sortingType,
        this.columnNameToSort,
        isDescSort
      );
  }

  redirectToEditSettings() {
    this.tabElement.select(0);
  }

  resetFilters() {
    this.spinner.show('customSpinner');
    this.infoLinksForm.reset();
    this.initializeform();
    if (this.currentUser.UserRoleID != UserRoles.Administrator) {
      this.toolbar = this.toolbar.filter(function (el: { id: string }) { return el.id != 'add' && el.id != 'deleteAll'; });
    }
    this.grid.clearRowSelection();
    this.grid.clearSorting();
    this.isSorting = false;
  }

  refereshGrid() {
    this.isGridLoading = true;
    this.spinner.show('customSpinner');
    this.ManageInfoLinksPaginationService.execute(this.currentState, this.companyId);
    this.grid.clearRowSelection();
  }

  exportToPrint() {
    const SelectedRows = this.grid.getSelectedRecords();
    let DataToExport: any;
    const Headers = [
      {
        field: 'description',
        displayName: 'Description'
      }, {
        field: 'link',
        displayName: 'Link'
      }, {
        field: 'notes',
        displayName: 'Notes'
      }];

    if (SelectedRows.length > 0) {
      DataToExport = this.formatInfoLinks(SelectedRows);
      printJS({
        printable: DataToExport,
        properties: Headers,
        header: '<h3 class="custom-h3">Manage Information Links</h3>',
        style: '.custom-h3 { color: black; text-align : center;} tr:nth-child(even) {background: #fbfcfc} tr:nth-child(odd) {background: #E8E3E2} th{ background: #7abaff  }  ',
        type: 'json'
      });
    }
    else {
      const query = this.currentState.search;
      this.ManageInfoLinksPaginationService.getManageInfoLinksFullData(query, this.companyId)
        .subscribe(resp => {
          DataToExport = this.formatInfoLinks(resp.body);
          printJS({
            printable: DataToExport,
            properties: Headers,
            header: '<h3 class="custom-h3">Manage Information Links</h3>',
            style: '.custom-h3 { color: black; text-align : center;} tr:nth-child(even) {background: #fbfcfc} tr:nth-child(odd) {background: #E8E3E2} th{ background: #7abaff  }  ',
            type: 'json'
          });
        });
    }
  }

  exportToPdf() {
    this.spinner.show('customSpinner');
    const SelectedRows = this.grid.getSelectedRecords();
    const query = this.currentState.search;
    const Head = [['Description', 'Link', 'Notes']];

    if (SelectedRows.length > 0) {
      const bodyData = this.formatInfoLinks(SelectedRows);
      const doc = new jsPDF('l', 'mm', 'a4');
      autoTable(doc, {
        head: Head,
        body: bodyData.map(Object.values)
      });
      doc.save('ManageInformationLinks.pdf');
      this.spinner.hide('customSpinner');
    }
    else {
      this.ManageInfoLinksPaginationService.getManageInfoLinksFullData(query, this.companyId)
        .subscribe(resp => {
          const bodyData = this.formatInfoLinks(resp.body);
          const doc = new jsPDF('l', 'mm', 'a4');
          autoTable(doc, {
            head: Head,
            body: bodyData.map(Object.values)
          });
          doc.save('ManageInformationLinks.pdf');
          this.spinner.hide('customSpinner');
        });
    }
  }

  exportToCSV() {
    this.spinner.show('customSpinner');
    const SelectedRows = this.grid.getSelectedRecords();
    const query = this.currentState.search;
    let formatedData: any;
    if (SelectedRows.length > 0) {
      formatedData = this.formatInfoLinks(SelectedRows);
      this.csvService.saveToCSv(formatedData, 'ManageInformationLinks');
      this.spinner.hide('customSpinner');
    }
    else {
      this.ManageInfoLinksPaginationService.getManageInfoLinksFullData(query, this.companyId)
        .subscribe(resp => {
          if (resp.body) {
            formatedData = this.formatInfoLinks(resp.body);
            this.csvService.saveToCSv(formatedData, 'ManageInformationLinks');
          }
          this.spinner.hide('customSpinner');
        });
    }
  }

  exportToExcel() {
    this.spinner.show('customSpinner');
    const SelectedRows = this.grid.getSelectedRecords();
    const query = this.currentState.search;
    let formatedData: any;
    if (SelectedRows.length > 0) {
      formatedData = this.formatInfoLinks(SelectedRows);
      this.excelService.exportAsExcelFile(formatedData, 'ManageInformationLinks');
      this.spinner.hide('customSpinner');
    }
    else {
      this.ManageInfoLinksPaginationService.getManageInfoLinksFullData(query, this.companyId)
        .subscribe(resp => {
          if (resp.body) {
            formatedData = this.formatInfoLinks(resp.body);
            this.excelService.exportAsExcelFile(formatedData, 'ManageInformationLinks');
          }
          this.spinner.hide('customSpinner');
        });
    }
  }

  formatInfoLinks(InfoLinks: any) {
    const FormattedInfoLinks = [];
    for (let index = 0; index < InfoLinks.length; index++) {
      const SingleInfoLink = new ManageInfoLinksModel();
      SingleInfoLink.link = InfoLinks[index].LinkUrltext ?? '';
      SingleInfoLink.description = InfoLinks[index].LinkDescriptText ?? '';
      SingleInfoLink.notes = InfoLinks[index].LinkNotesText ?? '';
      FormattedInfoLinks.push(SingleInfoLink);
    }
    return FormattedInfoLinks;
  }

  goToLink(url: string) {
    if (url.includes('http') || url.includes('https')) {
      window.open(url, '_blank');
    }
    else {
      window.open(`//${url}`, '_blank');
    }
  }

  getSearchData() {
    this.currentState.search = this.infoLinksForm.value.search;
    this.isGridLoading = true;
    this.spinner.show('customSpinner');
    if (this.isSorting) { this.getSortedData(); }
    else { this.ManageInfoLinksPaginationService.execute(this.currentState, this.companyId); }

    this.resetPageHeight();
  }

  public get winHeight() {
    return window.innerHeight;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.onResized();
  }

  onResized() {
    const rowheight1 = document.querySelector('.e-movablecontent .e-table').clientHeight;
    this.winInnerHeight = this.winHeight;
    const tableCalcHeight1 = this.winInnerHeight - 246;
    if (rowheight1 > 36 && rowheight1 <= tableCalcHeight1) {
      this.tableHeight = 'auto';
    }
    else if (document.querySelector('.e-content').classList.contains('no-records-overflow')) {
      this.tableHeight = 50;
    }
    else {
      this.winInnerHeight = this.winHeight;
      this.tableHeight = (this.winInnerHeight - 246);
    }
  }

  resetPageHeight() {
    const bottomContentHeight = document.querySelector('.innerDiv')?.clientHeight;
    this.ManageInfoList.subscribe((res) => {
      let result = res['result'];
      if (result.length <= 0) {
        this.tableHeight = 50;
        document.querySelector('.e-content').classList.add('no-records-overflow');
        this.isManageInfoList = false;
      }
      else {
        this.winInnerHeight = this.winHeight;
        this.tableHeight = (this.winInnerHeight - 246 - bottomContentHeight);
        document.querySelector('.e-content').classList.remove('no-records-overflow');
        this.isManageInfoList = true;
      }
    });

    if (this.ManageInfoList) { this.grid.refresh(); }
  }

  getMovableContentHeight() {
    const rowheight = document.querySelector('.e-content .e-table').clientHeight;
    this.winInnerHeight = this.winHeight;
    const tableCalcHeight = this.winInnerHeight - 246;
    if (rowheight > 36 && rowheight <= tableCalcHeight) {
      this.tableHeight = 'auto';
    }
  }
}